export enum ResourceSizeEnum {
  TINY = "TINY",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  CUSTOM = "CUSTOM",
}
